module.exports = __webpack_public_path__ + "img/img51.2498c853.png";